import type { DirectionId } from './labDirectionTags';

export const HOME_WALL_FOLDER = 'home-lab-wall';
export const HOME_WALL_PHOTOS_URL = '/api/files/public/home-lab-wall/';
export const HOME_WALL_ROTATION_MS = 5000;
export type WallPhotoCategory = DirectionId | 'achievements';

export interface WallPhoto {
  id: string;
  name: string;
  url: string;
  width: number;
  height: number;
}

export interface WallPhotosResponse {
  photos: Record<DirectionId, WallPhoto[]> & { achievements?: WallPhoto[] };
}

export function getWallPhotos(data: WallPhotosResponse | undefined, direction: WallPhotoCategory): WallPhoto[] {
  const candidates = data?.photos?.[direction];
  if (!Array.isArray(candidates)) return [];
  const seen = new Set<string>();
  const seenNames = new Set<string>();
  const seenPaths = new Set<string>();
  return candidates.filter(photo => {
    if (!photo || typeof photo.id !== 'string' || typeof photo.name !== 'string'
      || !new RegExp(`^${direction}-[a-z0-9][a-z0-9_-]*\\.(?:jpe?g|png|webp)$`, 'i').test(photo.name)
      || typeof photo.url !== 'string'
      || !/^\/uploads\/home-lab-wall\/[a-z0-9_-]+\.(?:jpe?g|png|webp)(?:\?v=[a-z0-9-]+)?$/i.test(photo.url)
      || !Number.isInteger(photo.width) || photo.width !== photo.height || photo.width < 256 || photo.width > 4096
      || seen.has(photo.id) || seenNames.has(photo.name.toLowerCase()) || seenPaths.has(photo.url.split('?')[0])) return false;
    seen.add(photo.id);
    seenNames.add(photo.name.toLowerCase());
    seenPaths.add(photo.url.split('?')[0]);
    return true;
  });
}

export function rotateWallPhoto(photos: readonly WallPhoto[], current: readonly WallPhoto[], slot: number, random = Math.random): WallPhoto[] {
  const selected = [...current];
  if (!current[slot]) return selected;
  const available = photos.filter(photo => !current.some(visible => visible.id === photo.id
    || visible.name.toLowerCase() === photo.name.toLowerCase() || visible.url.split('?')[0] === photo.url.split('?')[0]));
  if (available.length) selected[slot] = available[Math.floor(random() * available.length)];
  return selected;
}
